import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0TagRaw } from '@factorialco/f0-react'
import { Link, Pin } from '@factorialco/f0-react/icons/app'
import { Tooltip } from '@factorialco/f0-react/dist/experimental'

import i18n from 'modules/core/lib/i18n'
import type { WorkingConditions } from 'modules/job_catalog/lib/workingConditions'

interface WorkingConditionsCardProps {
  workingConditions?: WorkingConditions
}

const WorkingConditionsCard = ({ workingConditions }: WorkingConditionsCardProps) => {
  return (
    <Box
      border={{ all: { width: 's1', style: 'solid', color: 'grey200' } }}
      borderRadius={{ all: 'abs016' }}
      style={{ overflow: 'hidden' }}
    >
      <Box
        flexDirection="row"
        alignItems="center"
        justifyContent="spaceBetween"
        paddingTop="s16"
        paddingRight="s16"
        paddingBottom="s16"
        paddingLeft="s16"
      >
        <Box flexDirection="row" alignItems="center" gap="s8" style={{ maxWidth: '80%' }}>
          <Text.Normal size="200" color="grey800" weight="medium">
            {workingConditions?.name ?? 'Default working conditions'}
          </Text.Normal>
          {workingConditions?.inherited && (
            <Tooltip
              label={i18n.t('job_catalog.nodes.working_conditions.inherited_from', {
                nodeName:
                  workingConditions?.definedAtNode?.name ??
                  workingConditions?.definedAtNode?.uuid ??
                  i18n.t('job_catalog.nodes.working_conditions.parent_node'),
              })}
            >
              <Box style={{ display: 'inline-flex', alignItems: 'center', cursor: 'default' }}>
                <Link width={16} height={16} />
              </Box>
            </Tooltip>
          )}
        </Box>
        <F0TagRaw
          text={String(i18n.t('job_catalog.nodes.working_conditions.all_workplaces'))}
          icon={Pin}
        />
      </Box>
    </Box>
  )
}

export default WorkingConditionsCard
